import { __ } from 'react-i18n';

export const STOCK_INTERNAL = __('Skladom do 24 hod');
export const STOCK_EXTERNAL = __('Skladom v EU');
export const ON_STOCK = __('Skladom');
export const NO_STOCK = __('Na objednanie');
export const ON_DEMAND = __('Dostupnosť na vyžiadanie');
